import * as Yup from 'yup'

export const FaqFormValidation = Yup.object({
    title: Yup.string().required("Faq title is required!"),
    descrption: Yup.string().required("Description is required!"),
})